      <template>
        <div>
          <div class="d-flex flex-row justify-content-lg-between">
            <div  class="vali-text font-weight-bold">Validators</div>
            <div class="d-flex flex-row align-items-center">
              <button class="vali-btn" @click="goStaking()">Staking</button>
              <div class="header-search pt-1 d-flex flex-row align-items-lg-center">
                <input  class="search-bar-input"
                        @keyup.enter="submit"
                        v-model="keywords"
                        placeholder="Vaildator name or address"/>
                <img @click="submit" src="../../images/search/search.png"/>
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex flex-row align-items-center justify-content-between">
            <div class="vali-epoch w-25 d-flex flex-row align-items-center justify-content-between ">
              <div class="vali-epoch-text">
                <span>Epoch</span>
                <img src="../../images/validators/arrow-right.png"/>
              </div>
              <span class="vali-epoch-num">{{ totalData ? totalData.epoch : 0}}</span>
            </div>
            <div class="vali-epoch w-25 d-flex flex-row align-items-center justify-content-between ">
              <div class="vali-epoch-text">
                <span>Validators</span>
                <img src="../../images/validators/arrow-right.png"/>
              </div>
              <span class="vali-epoch-num">{{  totalData ? totalData.selectedCount : 0}}/{{  totalData ? totalData.count : 0}}</span>
            </div>
            <div class="vali-epoch d-flex flex-row align-items-center justify-content-between" style="width: 45%">
              <div class="vali-epoch-text">
                <span>Total Votes</span>
                <img src="../../images/validators/arrow-right.png"/>
              </div>
              <span class="vali-epoch-num">{{totalData ? parseFloat(totalData.totalVotes).toLocaleString() : 0}}</span>
            </div>
          </div>
          <div class="bg-card mt-4">
            <table class="main-table w-100 text-right">
              <tr class="text-break">
                <td class="pl-4 text-left text-middle-bond" style="width: 18%" >
                  Rank Name
                </td>
                <td class="text-left text-middle-bond" style="width: 10%">
                  Votes
                </td>
                <td class="text-left text-middle-bond" style="width: 12%" >
                  Avaliable Votes
                </td>
                <td class="text-left text-middle-bond" style="width: 10%">
                  Rewards Fee
                </td>
                <td class="text-left text-middle-bond" style="width: 10%">
                  Activity
                </td>
                <td class="text-left text-middle-bond" style="width: 10%">
                  Epoch
                </td>
                <td class="text-left text-middle-bond" style="width: 10%">
                  Status
                </td>
              </tr>
              <tr v-for="(item,index) in data_onshow" :key="index" class="hover-bg transTable">
                <td class="mb-none text-left d-flex flex-row align-items-center">
                  <div class="ml-4" style="font-size: 16px">{{ (cfg_pagination.page_current - 1) * cfg_pagination.page_size + index + 1}}</div>
                  <div class="vali-img ml-3">
                    <img src="../../images/validators/validators.png"/>
                  </div>
                  <div class="ml-3 d-flex flex-column align-items-start">
                    <div>
                      {{item.name}}
                    </div>
                    <span class="d-flex flex-row align-items-center">
                      <router-link :to="`/validators/${item.accountAddress}`">{{getSortAddress(item.accountAddress)}}</router-link>
                      <Copy :data="item.accountAddress"/>
                    </span>
                  </div>
                </td>
                <td class="text-left">
                  <div class="d-flex flex-column align-items-start">
                    <span>{{parseFloat(item.votedAmount).toLocaleString()}}</span>
                    <span>({{item.votePercent}}%)</span>
                  </div>
                </td>
                <td class="text-left">
                  <div>
                   {{parseFloat(item.activeAmount).toLocaleString() }}
                  </div>
                </td>
                <td class="text-left">
                  <div>
                   {{item.voteReward}}%
                  </div>
                </td>
                <td class="text-left">
                 <div class="d-flex flex-row align-items-center">
                   <span style="width: 55px">{{parseFloat(item.upTime).toFixed(2)}}%</span>
                   <div class="block-gas-line ml-1">
                     <div class="block-gas-line-bg" :style="{width:item.upTime+'%'}"></div>
                   </div>
                 </div>
                </td>
                <td class="text-left">
                  <div>
                    {{item.version}}
                  </div>
                </td>

                <td class="text-left">
                  <div>
                    {{item.isValidator=='1' ? 'selected' : 'candidate'}}
                  </div>
                </td>

              </tr>
            </table>
          </div>
          <PaginationSpTwo :config="cfg_pagination" @reloadList="getList()" class="py-4"/>
        </div>
      </template>

      <script>
      import Decimal from 'decimal.js'
      import { updateAge, parseBalance, getSortAddress,isAddress, isHeight } from '@/util/index'
      import paginationSp from '@/views/_comp/pagination_sp.vue'
      import Copy from "@/views/_frame/copy";
      import PaginationSpTwo from "@/views/_comp/paginationn_sp_two";

      export default {
        name: 'validatorTable',
        components: {
          PaginationSpTwo,
          Copy,
          paginationSp,
          // btnSortArr,
        },
        props: [
          'address',
          // 'data',
          'page',
          'cfg',
          'total',
          'type'
        ],
        data() {
          return {
            keywords: '',
            showAddress:false,
            showNumber:false,
            queryAddress:null,
            showRecordPage:false,//显示数据tab
            nowRecordPage:25,//当前显示数据
            recordPage:[
              {num:25},
              {num:50},
              {num:75},
              {num:100}
            ],//一页多少数据
            showImg:0,
            cfg_pagination: {
              'page_size': 25, //每页条目数量
              'page_current': 1, // 当前页
              'count_items': 0, //总个数，和总页数选填其一
              'btn_num': 5, // 按钮个数
              'turnpage_top': true, // 翻页时操作滚动置顶
              'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
            },
            data_onshow: [],
            totalTx:0,
            contract:'',
            bykey:'',
            pairlist:'',
            detail:'',
            totalData:null,//总数
          }
        },
        computed: {},
        watch: {},
        methods: {
          goStaking() {
            window.open('https://staking.maplabs.io','blank')
          },
          submit() {
            this.getList()
          },
          parseValue (input) {
            if(!input){
              return '0'
            }
            const { i, d } = parseBalance(input)
            if (i === '0' && d.slice(1, 4) === '000') {
              if (d === ',000,000,000,000,000,000') {
                return '0'
              } else {
                return '< 0.001'
              }
            }
            return `${i}.${d.slice(1, 4)}`
          },
          updateTimestamp(val) {
            return updateAge(val)
          },
          getSortAddress(val){
            return getSortAddress(val)
          },

          //选择当前一页多少数据
          actionSelectPage(item) {
            let v = this
            v.nowRecordPage=item.num
            v.cfg_pagination.page_size=item.num
            v.showRecordPage=false
            // console.log(v.showRecordPage)
            v.initData()
          },
          //跳转地址
          goAddress(item) {
            var address= item.address
            this.$router.push(
                {
                  path:"/address",
                  query:{address:address}
                }
            )
          },

          initData(){
            let v = this

            // if(!v.data)return

            v.cfg_pagination.page_current = 1

            if(v.cfg){
              v.cfg_pagination.page_size = v.cfg.page_size
              v.cfg_pagination.page_current = v.cfg.page_current
            }

            // 过滤数据
            v.getList()

            v.getTotalData()

          },

         async getTotalData() {
           let v = this
           let params;
           let result = await v.api('queryValidatorData',params,{
              vue: v,
              key_data: 'data',
            })
           if (result.code==200) {
             v.totalData=result.data
             v.totalData.totalVotes= new Decimal( v.totalData.totalVotes).div(Math.pow(10,18)).toFixed(6)
           }
          },

          async getList(){
            let v = this
            // 过滤条目
            let start = v.cfg_pagination.page_current
            let end = v.cfg_pagination.page_size
            // v.data_onshow = v.data.slice(start, end)
            let params;
            if (v.keywords.substr(0,2)=='0x') {
               params = {
                address:v.keywords,
                page: start,
                size: end
              }
            }
            else  {
              params = {
                name:v.keywords,
                page: start,
                size: end
              }
            }

            if(v.queryAddress){
              // console.log(isAddress(v.queryAddress),"tran param")
              if(isAddress(v.queryAddress)){
                v.showAddress = true;
                params.address = v.queryAddress
              }else if(isHeight(v.queryAddress)){
                v.showNumber = true
                params.number = v.queryAddress
              }

            }
            let result = await v.api('queryCommitteeList',params,{
              vue: v,
              key_data: 'data',
            })
            if (result.code==200) {
              v.data_onshow=result.data.list
              v.totalTx = result.data.total
            }

            for (var item of  v.data_onshow) {
              item.lockedAmount = new Decimal(item.lockedAmount).div(Math.pow(10,18)).toFixed()
              item.votedAmount = new Decimal(item.votedAmount).div(Math.pow(10,18)).toFixed()
              item.voteReward = new Decimal(item.voteReward).div(Math.pow(10,18)).toFixed()
              item.voteReward = new Decimal( item.voteReward ).mul(Math.pow(10,2)).toFixed()
              item.activeAmount = new Decimal(item.activeAmount).div(Math.pow(10,18)).toFixed()
            }
            // console.log(v.data_onshow)
            // 计算页码
            if(v.totalTx < 10000){
              v.cfg_pagination.count_pages = Math.ceil(v.totalTx/v.cfg_pagination.page_size)
            }else{
              v.cfg_pagination.count_pages = Math.ceil(10000/v.cfg_pagination.page_size)
            }

          },
        },
        created() {
          if(this.address){
            this.queryAddress = this.address
          }else{
            this.queryAddress = this.$route.params.number
          }
          this.initData()
          // this.actionRequest();
        },
        mounted() {
        },
        //beforeDestroy() {},
        //update() {},
        //activited() {},
        //beforeRouteUpdate() {},
        //filters: {},
      };
      </script>

      <style lang="scss" scoped>

      .trans-icon-img {
        width: 22px;
        height: 20px;
        background: url("../../images/transtion/trans-black.png")no-repeat;
        background-size: 100% auto;
      }

      .vali-text {
        font-size: 21px;
      }

      .vali-btn {
        width: 90px;
        height: 37px;
        border-radius: 10px;
        background: #0d6efd;
        color: white;
        margin-right: 10px;
      }

      .header-search{
        width: 420px;
        height: 40px;
        border-radius: 10px;
        box-sizing: border-box;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        //min-width: 230px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #fff;

        input{
          -webkit-appearance: none;
          border: none;
          background-color: transparent;
          height: 100%;
          padding-left: 35px;
          outline: none;
          width: 100%;
          &:focus{
            &~.sp-res-box{
              display: block;
            }
          }
        }

        img {
          cursor: pointer;
          width: 20px;
          height: 19px;
          margin-right: 21px;
        }

        .sp-res-box{
          position: absolute;
          top: 34px;
          left: 0;
          right: 0;
          padding-top: 5px;
          z-index: 9;
          display: none;

          &:hover{
            display: block;
          }

          .sp-res-card{
            margin: 0 5px;
            border-radius: 15px;
            background-color: #fff;
            box-shadow: 0px 1px 3px rgba(0,0,0,0.1);

            a{
              display: block;
              &:hover{
                background-color: rgba(0,0,0,0.03);
              }
            }
          }
        }
      }

      .vali-img {
        img {
          width: 38px;
        }
      }

      .block-gas-line {
        width: 50px;
        height: 15px;
        background: rgba(0,0,0,0.05);
        border-radius: 10.5px;
        margin-top: -4px;
      }

      .block-gas-line-bg {
        height: 15px;
        border-radius: 10.5px;
        background: #3772ff;
      }

      ::-webkit-input-placeholder {
        font-family: PingFangSC-Regular, PingFang SC;
        //font-weight: 400;
        color: #3772ff;
      }

      .vali-epoch {
        //padding: 3rem 2rem;
        padding: 39px 28px;
        box-sizing: border-box;
        height: 100px;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        background-color: white;
      }

      .vali-epoch-text {
        font-size: 18px;
        color: rgb(51, 51, 51);
          img {
            margin-left: 15px;
            width: 9px;
          }
      }

      .vali-epoch-num {
        font-size: 30px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }

      @media (max-width: 1000px) {
        .vali-epoch-num {
          font-size: 18px !important;
        }
      }

      </style>
